import * as Scrivito from "scrivito";
import defaultSocialHeaderButtonAttributes from "../_defaultSocialHeaderButtonAttributes";

const LinkedInSocialHeaderButton = Scrivito.provideObjClass(
  "LinkedInSocialHeaderButton",
  defaultSocialHeaderButtonAttributes,
);

export default LinkedInSocialHeaderButton;
